export default "__VITE_ASSET__a9deb96b__"